import axios from "@/helpers/axios";
const commonURL = "/users";

export default {
  /*
    member
  */
  async biz_member_change_name({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz-member/name`,
        data: payload
      });

      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async biz_member_changePassword({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz-member/password`,
        data: payload
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async biz_member_change_phoneNumber({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz-member/phone-number`,
        data: payload
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async biz_member_myInfo({ rootGetters, dispatch }) {
    try {
      const result = await axios({
        method: "get",
        url: `${commonURL}/biz-member/my-information?v=2`
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /*
    manager
  */
  async biz_manager_change_name({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz-manager/name`,
        data: payload
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async biz_manager_change_phoneNumber({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz-manager/phone-number`,
        data: payload
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async biz_manager_changePassword({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz-manager/password`,
        data: payload
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async biz_manager_myInfo({ rootGetters, dispatch }) {
    try {
      const result = await axios({
        method: "get",
        url: `${commonURL}/biz-manager/my-information?v=2`
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async biz_manager_member_info({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "get",
        url: `${commonURL}/biz-manager/member-information?page=${payload.page}&perPage=${payload.perPage}&q=${payload.q}&approveStatus=${payload.approveStatus}`
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async biz_manager_member_approval({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz-manager/member-status/${payload._id}`,
        data: {
          status: payload.status
        }
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /*
    bookmark
  */
  async replaceBookmark({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "post",
        url: `${commonURL}/biz/bookmark`,
        data: payload
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async appendBookmarkAddress({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "post",
        url: `${commonURL}/biz/add/bookmark`,
        data: payload
      });
      if (!result.data.success) throw result.data;
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async biz_update_bookmark({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios({
        method: "post",
        url: `${commonURL}/biz/bookmark`,
        data: payload
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async biz_delete_bookmark({}, payload) {
    try {
      const result = await axios({
        method: "delete",
        url: `${commonURL}/biz/bookmark/${payload.bookmarkId}`
      });
      return result.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /*
    RiderInfo
  */
  async getRiderInfo({ rootGetters, dispatch }, payload) {
    try {
      const result = await axios.get(
        `${commonURL}/riderInfo/by-orderId/${payload}`
      );
      if (result.data.success) return result.data;
      throw result.data;
    } catch (error) {
      throw error;
    }
  },
  /* 유저별 최근 사용한 출발지 주소 (20건) */
  async getRecentAddressFrom({}, payload) {
    try {
      const result = await axios({
        method: "get",
        url: `${commonURL}/biz/recentaddressfrom?all=${payload.all}&keyword=${payload.keyword}`
      });
      return result.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  /* 유저별 최근 사용한 경유, 도착지 주소 (20건) */
  async getRecentAddressTo({}, payload) {
    try {
      const result = await axios({
        method: "get",
        url: `${commonURL}/biz/recentaddressto?all=${payload.all}&keyword=${payload.keyword}`
      });
      return result.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async changeVatInformation({}, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz/vat-information`,
        data: payload
      });
      return result.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  //마켓팅 동의 수정
  async biz_agreeToMarketing({}, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz/agreedToMarketing`,
        data: payload
      });
      return result.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  //알림톡 수신 여부
  async biz_agreedToAlim({}, payload) {
    try {
      const result = await axios({
        method: "patch",
        url: `${commonURL}/biz/agreedToAlim`,
        data: payload
      });
      return result.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async getBookmarkAddress({}, payload) {
    try {
      const result = await axios(
        `${commonURL}/biz/my-bookmarkAddress?code=${payload.code}&keyword=${payload.keyword}`
      );
      return result.data;
    } catch (e) {
      throw e;
    }
  },

  async getExistCompanyName({}, payload) {
    try {
      const result = await axios({
        method: "post",
        url: `${commonURL}/biz-manager/exist/company-name`,
        data: payload,
        headers: {
          bypass: true
        }
      });
      return result.data;
    } catch (e) {
      throw e;
    }
  }
};
